package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.ToggleDemo
import example.shadcn_kotlin.ui.pages.components.demo.ToggleOutline
import example.shadcn_kotlin.ui.pages.components.demo.ToggleDisabled
import example.shadcn_kotlin.ui.pages.components.demo.ToggleWithText

@Page
@Composable
fun TogglePage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/toggle.md", mapOf("title" to listOf("Toggle"), "description" to listOf("A two-state button that can be either on or off."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/toggle"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/toggle#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import lucide_react.Bold
import react.FC
import react.Props
import react.dom.aria.ariaLabel
import shadcn.ui.components.Toggle
import web.cssom.ClassName

val ToggleDemo = FC<Props> {
    Toggle {
        ariaLabel = "Toggle italic"
        Bold { className = ClassName("h-4 w-4") }
    }
}"""){ 
 ToggleDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Toggle
""", lang= "kotlin", highlight= "")
            CodeBlock("""Toggle { + "Toggle" }
""", lang= "kotlin", highlight= "")
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("examples")
 }) {
                org.jetbrains.compose.web.dom.Text("Examples")
            }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("default")
 }) {
                org.jetbrains.compose.web.dom.Text("Default")
            }
            ComponentPreview("""import lucide_react.Bold
import react.FC
import react.Props
import react.dom.aria.ariaLabel
import shadcn.ui.components.Toggle
import web.cssom.ClassName

val ToggleDemo = FC<Props> {
    Toggle {
        ariaLabel = "Toggle italic"
        Bold { className = ClassName("h-4 w-4") }
    }
}"""){ 
 ToggleDemo {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("outline")
 }) {
                org.jetbrains.compose.web.dom.Text("Outline")
            }
            ComponentPreview("""import lucide_react.Italic
import react.FC
import react.Props
import react.dom.aria.ariaLabel
import shadcn.ui.components.Toggle
import web.cssom.ClassName

val ToggleOutline = FC<Props> {
    Toggle {
        variant = "outline"
        ariaLabel = "Toggle italic"
        Italic { className = ClassName("h-4 w-4") }
    }
}"""){ 
 ToggleOutline {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("with-text")
 }) {
                org.jetbrains.compose.web.dom.Text("With Text")
            }
            ComponentPreview("""import lucide_react.Italic
import react.FC
import react.Props
import react.dom.aria.ariaLabel
import shadcn.ui.components.Toggle
import web.cssom.ClassName

val ToggleWithText = FC<Props> {
    Toggle {
        ariaLabel = "Toggle italic"
        Italic { className = ClassName("m-2 h-4 w-4") }
        +"Italic"
    }
}"""){ 
 ToggleWithText {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("disabled")
 }) {
                org.jetbrains.compose.web.dom.Text("Disabled")
            }
            ComponentPreview("""import lucide_react.Underline
import react.FC
import react.Props
import react.dom.aria.ariaLabel
import shadcn.ui.components.Toggle
import web.cssom.ClassName

val ToggleDisabled = FC<Props> {
    Toggle {
        disabled = true
        ariaLabel = "Toggle italic"
        Underline { className = ClassName("h-4 w-4") }
    }
}"""){ 
 ToggleDisabled {} 
 }
        }
    }
}
